import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import EarningsPopup from './EarningsPopup';

let globalEarningsRef: any = null;

export const triggerEarningsPopup = (amount: number) => {
  if (globalEarningsRef && globalEarningsRef.current) {
    globalEarningsRef.current.trigger(amount);
  }
};

interface EarningsPopupRef {
  trigger: (amount: number) => void;
}

const EarningsPopupManager = forwardRef<EarningsPopupRef>((props, ref) => {
  const earningsRef = useRef<EarningsPopupRef | null>(null);

  useImperativeHandle(ref, () => ({
    trigger: (amount: number) => {
      earningsRef.current?.trigger(amount);
    },
  }));

  React.useEffect(() => {
    globalEarningsRef = { current: { trigger: (amount: number) => earningsRef.current?.trigger(amount) } };
  }, []);

  return <EarningsPopup ref={earningsRef} />;
});

EarningsPopupManager.displayName = 'EarningsPopupManager';

export default EarningsPopupManager;